
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mock-login",
      function () {
        return require("private-next-pages/mock-login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mock-login"])
      });
    }
  